var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 98 98",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "&lt;Group&gt;",
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "&lt;Group&gt;",
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffda2d",
    points: "93.2 54.5 87.1 60.4 88.6 68.7 81.1 64.8 73.7 68.7 75.1 60.4 69.1 54.5 77.4 53.3 81.1 45.7 84.8 53.3 93.2 54.5",
    "data-name": "&lt;Path&gt;",
    className: "colorffda2d svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "&lt;Group&gt;",
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffda2d",
    points: "71.7 43.9 60.3 55 63 70.6 49 63.2 35 70.6 37.7 55 26.3 43.9 42 41.6 49 27.4 56 41.6 71.7 43.9",
    "data-name": "&lt;Path&gt;",
    className: "colorffda2d svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "&lt;Group&gt;",
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffda2d",
    points: "28.6 54.5 22.6 60.4 24.1 68.7 16.6 64.8 9.2 68.7 10.6 60.4 4.5 54.5 12.9 53.3 16.6 45.7 20.3 53.3 28.6 54.5",
    "data-name": "&lt;Path&gt;",
    className: "colorffda2d svgShape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStarIcon);
export default __webpack_public_path__ + "static/media/threeStarIcon.71a6b83b07870f55486b7a644ce5ab2d.svg";
export { ForwardRef as ReactComponent };